/* ============================================================
   Wardrobe Wholesalers: multi-step quote form
   Drives snippets/wwlp-quote-steps.liquid. Moves between steps,
   auto-advances picture choices, validates each step, and blocks
   any submit that is not on the last step with a job we take.

   The job rule (Will, 2026-10-20) is on TOTAL doors:
     total = bedrooms x doors per bedroom ("4+" counts as 4)
     a single door per bedroom  -> stop (they don't make single doors)
     total of 2 doors           -> stop (one room, one pair)
     3 doors or more            -> goes through
   Sending, the CRM post, the conversion token and the thank-you
   redirect all stay in assets/ma-lead-forms.js.
   Vanilla ES5, safe with more than one form on the page.
   ============================================================ */
(function () {
  'use strict';

  if (window.__wwqsLoaded) return;
  window.__wwqsLoaded = true;

  var ORDER = ['rooms', 'doors', 'style', 'when', 'contact', 'name'];
  var CHOICES = ['rooms', 'doors', 'style', 'when'];
  var BACK = { doors: 'rooms', reject: 'doors', style: 'doors', when: 'style', contact: 'when', name: 'contact' };
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var ADVANCE_MS = 340;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function Stepper(root) {
    this.root = root;
    this.form = root.closest('form');
    this.current = 'rooms';
    this.keyboard = false;
    this.timer = null;
    this.steps = {};
    this.values = {};
    this.nums = {};
    var self = this;
    qa(root, '[data-wwqs-step]').forEach(function (el) { self.steps[el.getAttribute('data-wwqs-step')] = el; });
    qa(root, '[data-wwqs-value]').forEach(function (el) { self.values[el.getAttribute('data-wwqs-value')] = el; });
    this.total = q(root, '[data-wwqs-total]');
    this.back = q(root, '[data-wwqs-back]');
    this.next = q(root, '[data-wwqs-next]');
    this.bar = q(root, '[data-wwqs-bar]');
    this.count = q(root, '[data-wwqs-count]');
    this.bind();
    this.sync();
  }

  Stepper.prototype.value = function (name) {
    return this.values[name] ? this.values[name].value : '';
  };

  /* 'ok', 'single' or 'pair'; '' until both numbers are known. */
  Stepper.prototype.verdict = function () {
    var rooms = this.nums.rooms;
    var doors = this.nums.doors;
    if (!rooms || !doors) return '';
    if (doors === 1) return 'single';
    if (rooms * doors <= 2) return 'pair';
    return 'ok';
  };

  Stepper.prototype.updateTotal = function () {
    if (!this.total) return;
    var rooms = this.nums.rooms;
    var doors = this.nums.doors;
    this.total.value = rooms && doors ? String(rooms * doors) + (rooms >= 4 || doors >= 4 ? '+' : '') : '';
  };

  Stepper.prototype.bind = function () {
    var self = this;
    var root = this.root;

    /* Arrow keys move through radios and fire change; only a pointer
       pick auto-advances, so keyboard users are never thrown forward. */
    root.addEventListener('keydown', function (evt) {
      self.keyboard = true;
      var t = evt.target;
      if (evt.key !== 'Enter' || !t) return;
      if (t.type === 'radio') {
        evt.preventDefault();
        if (!t.checked) t.click();
        self.goNext();
      } else if (t.closest && t.closest('[data-wwqs-step="contact"]')) {
        evt.preventDefault();
        self.goNext();
      }
    });
    root.addEventListener('pointerdown', function () { self.keyboard = false; });

    /* Checked and keyboard-focus state lives on the label, so the
       whole card lights up (no reliance on :has()). */
    qa(root, '[data-wwqs-choice]').forEach(function (input) {
      var card = input.parentNode;
      var name = input.getAttribute('data-wwqs-choice');
      input.addEventListener('change', function () {
        qa(root, 'input[name="' + input.name + '"]').forEach(function (other) {
          other.parentNode.classList.toggle('is-checked', other.checked);
        });
        if (self.values[name]) self.values[name].value = input.value;
        var num = parseInt(input.getAttribute('data-wwqs-num'), 10);
        if (num) self.nums[name] = num;
        self.updateTotal();
        self.sync();
        self.autoAdvance();
      });
      /* Tapping the answer that is already chosen (after Back) moves on too. */
      card.addEventListener('pointerdown', function () { card.__wasChecked = input.checked; });
      input.addEventListener('click', function () {
        if (card.__wasChecked && input.checked) self.autoAdvance();
        card.__wasChecked = false;
      });
      input.addEventListener('focus', function () {
        var visible = true;
        try { visible = input.matches(':focus-visible'); } catch (e) {}
        card.classList.toggle('is-focus', visible);
      });
      input.addEventListener('blur', function () { card.classList.remove('is-focus'); });
    });

    this.back.addEventListener('click', function () { self.goBack(); });
    this.next.addEventListener('click', function () { self.goNext(); });

    qa(root, '.wwqs__input').forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') === 'true' && self.fieldError(input) === '') self.clearError(input);
      });
    });
  };

  Stepper.prototype.autoAdvance = function () {
    if (this.keyboard) return;
    var self = this;
    clearTimeout(this.timer);
    this.timer = setTimeout(function () { self.goNext(); }, reduceMotion ? 0 : ADVANCE_MS);
  };

  Stepper.prototype.goNext = function () {
    clearTimeout(this.timer);
    var cur = this.current;
    if (cur === 'contact') {
      if (this.validateStep('contact')) this.show('name', 1);
      return;
    }
    if (CHOICES.indexOf(cur) === -1 || !this.value(cur)) return;
    if (cur === 'doors') {
      var verdict = this.verdict();
      if (verdict !== 'ok') {
        this.showReject(verdict);
        return;
      }
    }
    this.show(ORDER[ORDER.indexOf(cur) + 1], 1);
  };

  Stepper.prototype.showReject = function (reason) {
    qa(this.steps.reject, '[data-wwqs-reason]').forEach(function (el) {
      el.hidden = el.getAttribute('data-wwqs-reason') !== reason;
    });
    this.show('reject', 1);
  };

  Stepper.prototype.goBack = function () {
    clearTimeout(this.timer);
    var prev = BACK[this.current];
    if (prev) this.show(prev, -1);
  };

  Stepper.prototype.show = function (name, dir) {
    var from = this.steps[this.current];
    var to = this.steps[name];
    if (!to) return;
    this.current = name;

    if (from !== to) {
      from.classList.remove('is-active', 'is-in-fwd', 'is-in-back');
      from.hidden = true;
    }
    to.hidden = false;
    to.classList.remove('is-in-fwd', 'is-in-back');
    if (!reduceMotion) {
      void to.offsetWidth; /* restart the entrance animation */
      to.classList.add(dir < 0 ? 'is-in-back' : 'is-in-fwd');
    }
    to.classList.add('is-active');
    this.sync();

    var heading = qa(to, '.wwqs__q').filter(function (h) { return !h.closest('[hidden]'); })[0];
    if (heading) {
      try { heading.focus({ preventScroll: true }); } catch (e) { heading.focus(); }
    }
    var rect = this.root.getBoundingClientRect();
    if (rect.top < 0 || rect.top > window.innerHeight * 0.6) {
      this.root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
  };

  Stepper.prototype.sync = function () {
    var idx = ORDER.indexOf(this.current);
    var stepNo = idx < 0 ? 2 : idx + 1;
    var reject = this.current === 'reject';
    this.root.setAttribute('data-wwqs-current', this.current);
    if (this.bar) this.bar.style.transform = 'scaleX(' + (stepNo / ORDER.length) + ')';
    if (this.count) this.count.textContent = reject ? 'Not one for a quote' : 'Step ' + stepNo + ' of ' + ORDER.length;

    this.back.hidden = this.current === 'rooms';
    var choice = CHOICES.indexOf(this.current) !== -1;
    this.next.hidden = !(choice || this.current === 'contact');
    this.next.disabled = choice && !this.value(this.current);
  };

  /* ---- validation, same error slots ma-lead-forms.js uses ---- */
  Stepper.prototype.msg = function (attr, fallback) {
    return (this.form && this.form.getAttribute(attr)) || fallback;
  };

  Stepper.prototype.fieldError = function (input) {
    var v = (input.value || '').trim();
    var role = input.getAttribute('data-ma-role');
    if (v === '') return this.msg('data-ma-msg-required', 'This field is required.');
    if (role === 'email' && !EMAIL_RE.test(v)) return this.msg('data-ma-msg-email', 'Enter a valid email address.');
    if (role === 'phone' && v.replace(/\D/g, '').length < 8) return 'Enter a valid phone number.';
    return '';
  };

  Stepper.prototype.setError = function (input, text) {
    input.setAttribute('aria-invalid', 'true');
    var el = document.getElementById(input.getAttribute('aria-describedby'));
    if (el) el.textContent = text;
  };

  Stepper.prototype.clearError = function (input) {
    input.removeAttribute('aria-invalid');
    var el = document.getElementById(input.getAttribute('aria-describedby'));
    if (el) el.textContent = '';
  };

  Stepper.prototype.validateStep = function (name) {
    var self = this;
    var first = null;
    qa(this.steps[name], '.wwqs__input').forEach(function (input) {
      var err = self.fieldError(input);
      if (err) {
        self.setError(input, err);
        if (!first) first = input;
      } else {
        self.clearError(input);
      }
    });
    if (first) first.focus();
    return !first;
  };

  /* Called from the document capture listener before ma-lead-forms.js
     sees the submit. Returns true only for a complete, accepted job. */
  Stepper.prototype.allowSubmit = function () {
    var verdict = this.verdict();
    if (verdict === 'single' || verdict === 'pair') {
      this.showReject(verdict);
      return false;
    }
    for (var i = 0; i < CHOICES.length; i++) {
      if (!this.value(CHOICES[i])) {
        this.show(CHOICES[i], -1);
        return false;
      }
    }
    if (this.current !== 'name') {
      this.goNext();
      return false;
    }
    if (!this.validateStep('contact')) {
      this.show('contact', -1);
      return false;
    }
    return this.validateStep('name');
  };

  /* Pre-pick a style when the popup is opened from a door style card. */
  Stepper.prototype.preselectStyle = function (style) {
    if (this.current === 'reject') this.show('doors', -1);
    if (!style) return;
    var self = this;
    qa(this.root, '[data-wwqs-choice="style"]').forEach(function (input) {
      input.checked = input.value === style;
      input.parentNode.classList.toggle('is-checked', input.checked);
      if (input.checked) self.values.style.value = style;
    });
    this.sync();
  };

  function stepperFor(el) {
    var root = el && el.querySelector ? el.querySelector('[data-wwqs]') : null;
    return root && root.__wwqs ? root.__wwqs : null;
  }

  /* Capture phase on document: runs before ma-lead-forms.js's own
     listener on the form, whatever the script order. */
  document.addEventListener('submit', function (evt) {
    var stepper = stepperFor(evt.target);
    if (!stepper) return;
    if (!stepper.allowSubmit()) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest ? evt.target.closest('[data-wwlp-quote], a[href="#wwlp-quote"]') : null;
    if (!trigger) return;
    var modal = document.querySelector('[data-wwlp-quote-modal]');
    var stepper = stepperFor(modal);
    if (stepper) stepper.preselectStyle(trigger.getAttribute('data-style') || '');
  });

  function initAll(scope) {
    qa(scope || document, '[data-wwqs]').forEach(function (root) {
      if (!root.__wwqs) root.__wwqs = new Stepper(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (evt) { initAll(evt.target); });
})();
